import React from 'react';
import { Autocomplete, TextField, Typography, Box } from '@mui/material';

export default function ProjectSelector({ projects = [], value, onChange, error, helperText, disabled }) {
  const options = projects.map((p) => ({
    _id: p._id,
    label: p.name || '',
    project_number: p.project_number || '',
    client_id: p.client_id,
    engineer: p.engineer,
    location: p.location || p.place || '',
  }));

  const selected = options.find((o) => o._id === (value?._id || value)) || null;

  return (
    <Autocomplete
      options={options}
      getOptionLabel={(o) => o.label}
      isOptionEqualToValue={(o, v) => o._id === (v?._id || v)}
      value={selected}
      onChange={(_, val) => onChange(val)}
      disabled={disabled}
      renderOption={(props, option) => (
        <li {...props}>
          <Box>
            <Typography variant="body2" fontWeight={600}>{option.label}</Typography>
            <Typography variant="caption" color="text.secondary">
              {[option.project_number, option.location].filter(Boolean).join(' · ')}
            </Typography>
          </Box>
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label="โปรเจกต์ *"
          size="small"
          error={!!error}
          helperText={helperText}
          sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
        />
      )}
    />
  );
}
